import { render, staticRenderFns } from "./RequestJob.vue?vue&type=template&id=b0b640a0&scoped=true&"
import script from "./RequestJob.vue?vue&type=script&lang=js&"
export * from "./RequestJob.vue?vue&type=script&lang=js&"
import style0 from "./RequestJob.vue?vue&type=style&index=0&id=b0b640a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b640a0",
  null
  
)

export default component.exports